import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["enabledCount", "limitCount", "remainingCount"]

  static values = {
    maxExtensions: Number,
  }

  boundCheckboxChange = (event) => {
    if (event.target.matches(".custom-checkbox")) {
      this.#updateLimitInfo()
    }
  }

  connect() {
    this.element.addEventListener("change", this.boundCheckboxChange)
    this.#applyLimitToCheckboxes()
  }

  disconnect() {
    this.element.removeEventListener("change", this.boundCheckboxChange)
  }

  #selectedCount() {
    return this.element.querySelectorAll(".custom-checkbox:checked").length
  }

  #updateLimitInfo() {
    const limit = this.maxExtensionsValue
    const selected = this.#selectedCount()
    const available = limit - selected

    if (this.hasEnabledCountTarget) {
      this.enabledCountTarget.textContent = String(selected)
    }
    if (this.hasLimitCountTarget) {
      this.limitCountTarget.textContent = String(limit)
    }
    if (this.hasRemainingCountTarget) {
      this.remainingCountTarget.textContent = String(available)
    }

    if (available <= 0) {
      this.#deactivateUncheckedCheckboxes()
    } else {
      this.#activateCheckboxes()
    }
  }

  #applyLimitToCheckboxes() {
    if (this.#selectedCount() >= this.maxExtensionsValue) {
      this.#deactivateUncheckedCheckboxes()
    }
  }

  #deactivateUncheckedCheckboxes() {
    this.element.querySelectorAll(".custom-checkbox").forEach((checkbox) => {
      if (!checkbox.checked) {
        checkbox.disabled = true
      }
    })
  }

  #activateCheckboxes() {
    this.element.querySelectorAll(".custom-checkbox").forEach((checkbox) => {
      checkbox.disabled = false
    })
  }
}
